import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomerService } from '../../services/customer.service';
import { GlobalsService } from '../../services/globals.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';

export interface NsfBounceModalData {
	transaction: any;
	config: any;
}

@Component({
	selector: 'app-nsf-bounce-modal',
	templateUrl: './nsf-bounce-modal.component.html',
	styleUrls: ['./nsf-bounce-modal.component.scss']
})
export class NsfBounceModalComponent implements OnInit {
	nsfForm: UntypedFormGroup;
	glAccounts: any[] = [];
	allGlAccounts: any[] = [];
	glDropdownOpen = false;
	processing = false;
	error = '';

	constructor(
		public dialogRef: MatDialogRef<NsfBounceModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: NsfBounceModalData,
		private fb: UntypedFormBuilder,
		private customerService: CustomerService,
		private globalsService: GlobalsService,
		private globalSearchService: GlobalSearchService,
	) {}

	ngOnInit(): void {
		const defaultFee = this.data.config?.nsf?.defaultFee ?? 25.00;
		const defaultGl = this.data.config?.nsf?.defaultGlAccount ?? '';

		const today = new Date();
		const dateStr = today.getFullYear() + '-' +
			String(today.getMonth() + 1).padStart(2, '0') + '-' +
			String(today.getDate()).padStart(2, '0');

		this.nsfForm = this.fb.group({
			date: [dateStr, Validators.required],
			feeAmount: [defaultFee, [Validators.required, Validators.min(0)]],
			glAccount: [defaultGl, Validators.required],
			reason: ['NSF - Bounced Check', Validators.required],
		});

		this.globalsService.getGLAccounts().subscribe((accounts: any[]) => {
			this.allGlAccounts = accounts || [];
			this.glAccounts = this.allGlAccounts;
		});
	}

	onGlInput(val: string): void {
		if (!val) {
			this.glAccounts = this.allGlAccounts;
		} else {
			const lower = val.toLowerCase();
			this.glAccounts = this.allGlAccounts.filter(a =>
				(a.accountcode || '').toLowerCase().includes(lower) ||
				(a.accountname || '').toLowerCase().includes(lower)
			);
		}
		this.glDropdownOpen = true;
	}

	onGlFocus(): void {
		this.glAccounts = this.allGlAccounts;
		this.glDropdownOpen = true;
	}

	onGlBlur(): void {
		setTimeout(() => this.glDropdownOpen = false, 150);
	}

	selectGlAccount(acct: any): void {
		this.nsfForm.get('glAccount').setValue(acct.accountcode);
		this.glDropdownOpen = false;
	}

	get tran(): any {
		return this.data.transaction || {};
	}

	processNsf(): void {
		if (!this.nsfForm.valid || this.processing) return;
		this.processing = true;
		this.error = '';

		const payload = {
			id: this.tran.id,
			voiddate: this.nsfForm.get('date').value,
			reason: this.nsfForm.get('reason').value,
			nsf_fee_amount: this.nsfForm.get('feeAmount').value,
			nsf_fee_gl_account: this.nsfForm.get('glAccount').value,
		};

		this.customerService.nsfBounceCheck(payload).subscribe(
			(res: any) => {
				this.processing = false;
				if (res?.success) {
					this.globalSearchService.showNotification(
						'NSF processed — payment reversed & fee applied',
						'success', 'bottom', 'left'
					);
					this.dialogRef.close({ success: true, result: res });
				} else {
					this.error = res?.error || 'Unexpected error processing NSF';
				}
			},
			(err) => {
				this.processing = false;
				this.error = 'Server error — please try again';
			}
		);
	}

	close(): void {
		this.dialogRef.close({ success: false });
	}
}
